import {SafeRecord} from '../../types/SafeRecord';
import {DANGEROUS_KEYS} from './DANGEROUS_KEYS';

interface AssignSafelyOptions {
  allowedKeys?: string[];
}

export const assignSafely = <T extends SafeRecord, K extends string | number, V extends unknown>(
  target: T,
  key: K,
  value: V,
  options: AssignSafelyOptions = {}
): T & Record<K, V> => {
  if (
    (typeof key !== 'string' && typeof key !== 'number') ||
    DANGEROUS_KEYS.includes(key as (typeof DANGEROUS_KEYS)[number])
  ) {
    throw new Error(`Key cannot be assigned.`);
  }

  if (options.allowedKeys && !options.allowedKeys.includes(String(key))) {
    throw new Error(`Key is not allowed to be assigned in allowedKeys.`);
  }

  // TypeScript cast needed for dynamic key assignment after safety validation above
  // eslint-disable-next-line eag/safe-object-access, -eslint/no-explicit-any
  (target as any)[key] = value;

  return target as T & Record<K, V>;
};
